/* ------------------------------------------------------------
   Horizontal filter bar behaviour (Nilkamal-style dropdowns).
   Pure document-level delegation so it survives facets.js
   re-rendering the bar after every filter change.
   - Only one dropdown open at a time.
   - Clicking a checkbox/label inside a dropdown keeps it open.
   - Clicking outside, or pressing Escape, closes all.
   The <details> are `is="accordion-details"` custom elements
   with an animating `open` setter — we just flip `.open`.
   ------------------------------------------------------------ */
(function () {
  var SELECTOR = '.facets-horizontal';

  function closeAll(except) {
    document.querySelectorAll(SELECTOR + ' details[open]').forEach(function (d) {
      if (d === except) return;
      try {
        d.open = false;
      } catch (e) {
        d.removeAttribute('open');
      }
    });
  }

  // Whenever a filter opens, close every other one. The `toggle` event fires
  // exactly when open state changes (however it was triggered) and does NOT
  // bubble, so we listen in the capture phase at the document.
  document.addEventListener(
    'toggle',
    function (event) {
      var d = event.target;
      if (!d || !d.closest || !d.closest(SELECTOR)) return;
      if (d.open) closeAll(d);
    },
    true
  );

  // Click outside the bar closes everything; clicks inside a panel (ticking
  // checkboxes) are left alone.
  document.addEventListener('click', function (event) {
    if (event.target.closest(SELECTOR)) return;
    closeAll(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll(null);
  });

  /* ----------------------------------------------------------
     Mobile bottom-sheet sort: the visible radio list drives a
     hidden <select is="facet-short" id="SortBy-mobile">, so
     facets.js performs the same AJAX sort as everywhere else.
     Delegated at document level to survive re-renders.
     ---------------------------------------------------------- */
  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio || radio.name !== 'mobile_sort' || !radio.checked) return;

    var select = document.getElementById('SortBy-mobile');
    if (select && select.value !== radio.value) {
      select.value = radio.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Close the sort sheet after a choice is made (UL behaviour).
    var sheet = document.getElementById('SortDrawer');
    if (sheet && typeof sheet.hide === 'function') sheet.hide();
  });
})();